<template>
  <transition name="el-zoom-in-top">
    <div class='localeChange_box' ref="localeChangeBox">
      <div class="arrows"></div>
      <div
      v-for="item in localeList"
      class="localeChange_item"
      :class="{'localeChange_item-active': curLocale === item.value}"
      @click="changeLocale(item.value)"
      :key="item.value"
    >{{ item.name }}</div>
    </div>
  </transition>
</template>
<script>
import {setLang} from '../mx-service/libs/locale'
import device from '@/mx-service/libs/utils/device'
export default {
  name: 'localeChange',
  data(){
    return{
      localeList: [{
        value: 'zh-CN',
        name: '中文'
      },{
        value: 'en-US',
        name: 'English'
      },{
        value: 'ja-JP',
        name: '日本語'
      }],
      curLocale: 'zh-CN',
    }
  },
  methods: {
    changeLocale(e){
      setLang(e)
      localStorage.setItem('locale', e)
      this.curLocale = e
      this.$emit('localeChange', e)
      this.closeBox()
    },
    closeBox(){
      this.$emit('closeBox');
    }
  },
  mounted(){
    // this.curLocale = getLang()
    const _locale = localStorage.getItem('locale')
    this.curLocale = _locale || 'zh-CN'
    this.$nextTick(() => {
      const target = this.$refs.localeChangeBox;
      if(device.isMobile()) return
      document.addEventListener('mousedown', (event) => {
        if (!target.contains(event.target)) {
          this.closeBox()
        }
      });
    });
  }
}
</script>
<style lang='less' scoped>
.localeChange_box {
  width: 130px;
  background: #fff;
  position: absolute;
  top: 35px;
  left: -25px;
  border-radius: 8px;
  z-index: 1;
  padding: 5px 20px;
  box-sizing: border-box;

  .arrows {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent #fff transparent;
    position: absolute;
    top: -8px;
    left: 50%;
    transform: translateX(-50%);
  }

  .localeChange_item {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #E8E8E8;

    &:last-child {
      border-bottom: 0;
    }

    &-active {
      color: #04A0EE;
    }
  }
}
</style>
